<template>
  <div>
    <Advice v-if="isLoading" img="pencil" priority="low-gray">
      上位5ページを参考に、改善したいページに不足している可能性がある内容を考えています<span
        class="c-loading-dots"
      ></span>
    </Advice>
    <Advice v-else img="pencil" priority="low-gray">
      <p v-if="isError">
        申し訳ございません。問題が発生したため、AIからの回答を受け取れませんでした。<br />上位ページのタイトル・ディスクリプション・見出しテキストなどを参考に、画面右「見出し構成案」をご検討ください。
      </p>
      <p v-else-if="isPolicyError">
        調査したキーワードはChat
        API(GPT-3.5)のポリシーに反する内容だったため、AIからの回答を受け取れませんでした。<br />上位ページのタイトル・ディスクリプション・見出しテキストなどを参考に、画面右「見出し構成案」をご検討ください。
      </p>
      <div v-else-if="summaryItems.length" class="c-text--free">
        <p>
          上位5ページに共通する内容で、改善したいページに不足している可能性がある内容を以下にまとめています。<br /><span
            class="c-text--bold"
            >上位表示ページに共通する要素として見出しを追加する際のヒント</span
          >としてください。
        </p>
        <ol class="c-list--decimal">
          <li
            v-for="(item, index) in summaryItems"
            :key="index"
            class="p-contentrewrite-proposal-summary-headings__item"
          >
            <div>
              {{ item.summary }}
            </div>
            <div class="l-mt-3">▼上位5記事の見出し抜粋</div>
            <ul class="c-list--disc">
              <li v-for="(header, hIndex) in item.headers" :key="hIndex">
                {{ header.text }}
                <div v-if="header.url">
                  <a
                    target="_blank"
                    class="c-link--blank c-text--clamp"
                    :href="header.url"
                    >{{ header.url }}</a
                  >
                </div>
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <p v-else>
        上位5ページの見出しが見つかりませんでした。<br />上位ページのタイトル・ディスクリプション・見出しテキストなどを参考に、画面右「見出し構成案」をご検討ください。
      </p>
    </Advice>
  </div>
</template>

<script>
import Advice from '@/components/Advice';
import axios from 'axios';
import apiProjects from '@/api/projects';
export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    keyword: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    }
  },
  components: {
    Advice
  },
  data() {
    return {
      isLoading: true,
      isError: false,
      isPolicyError: false,
      cancelToken: {
        serps: null
      },
      serpsItems: [],
      summaryItems: [],
      expiresAt: Date.now() + 5 * 60 * 1000,
      timeoutDelay: 5000,
      timeoutId: null
    };
  },
  created() {
    this.fetchSerps();
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
    if (this.cancelToken.serps) {
      this.cancelToken.serps.cancel();
    }
  },
  methods: {
    fetchSerps() {
      const params = {
        keyword: this.keyword,
        dateJst: this.$options.filters.dateText(this.createdAt, 'YYYY-MM-DD'),
        location: 'tokyo',
        engine: 'google',
        device: 'desktop',
        fromRank: 1,
        toRank: 5
      };
      this.cancelToken.serps = axios.CancelToken.source();

      return apiProjects.serps
        .get(
          params,
          this.auth.idToken,
          this.project.id,
          this.cancelToken.serps.token
        )
        .then(response => {
          this.serpsItems = response.data.items;
          this.fetchSummaryProposalHeadings();
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            if (Date.now() < this.expiresAt) {
              this.timeoutId = setTimeout(this.fetchSerps, this.timeoutDelay);
            } else {
              this.isError = true;
              this.isLoading = false;
            }
          }
        });
    },
    async fetchSummaryProposalHeadings() {
      const serpsUrls = this.serpsItems
        .filter(
          item =>
            this.$options.filters.removeTrailingSlash(item.url) !==
            this.$options.filters.removeTrailingSlash(this.url)
        )
        .map(item => item.url);
      const params = {
        keyword: this.keyword,
        url: this.url,
        urls: serpsUrls,
        token: this.token
      };

      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}/beta/projects/${this.project.id}/header-summary-proposal`,
          params,
          {
            headers: {
              Authorization: `Bearer ${this.auth.idToken}`,
              'X-From': location.href
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.summaryItems = response.data.items;
          } else {
            this.isPolicyError = true;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isError = true;
          this.isLoading = false;
        })
        .finally(() => {
          this.$emit('fetched');
        });
    }
  }
};
</script>
